var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.weiUnits = exports.gweiUnits = exports.etherUnits = void 0;
  exports.etherUnits = {
    gwei: 9,
    wei: 18
  };
  exports.gweiUnits = {
    ether: -9,
    wei: 9
  };
  exports.weiUnits = {
    ether: -18,
    gwei: -9
  };
  //# sourceMappingURL=unit.js.map
  return exports;
}